// Brand palette. A calm indigo → violet primary with refined neutrals, tuned for both modes.

export const brand = {
  primary: '#4F46E5', // indigo-600
  primaryDark: '#4338CA',
  primaryLight: '#818CF8',
  secondary: '#7C3AED', // violet-600
  success: '#059669',
  warning: '#D97706',
  error: '#DC2626',
  info: '#0891B2',
};

// Gradient reused by the logo, hero surfaces and primary CTAs.
export const brandGradient = 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 55%, #A855F7 100%)';

const GREY = {
  50: '#F8FAFC',
  100: '#F1F5F9',
  200: '#E2E8F0',
  300: '#CBD5E1',
  400: '#94A3B8',
  500: '#64748B',
  600: '#475569',
  700: '#334155',
  800: '#1E293B',
  900: '#0F172A',
};

export const getPalette = (mode) => {
  const light = mode === 'light';
  return {
    mode,
    primary: { main: brand.primary, dark: brand.primaryDark, light: brand.primaryLight, contrastText: '#fff' },
    secondary: { main: brand.secondary, contrastText: '#fff' },
    success: { main: brand.success, contrastText: '#fff' },
    warning: { main: brand.warning, contrastText: '#fff' },
    error: { main: brand.error, contrastText: '#fff' },
    info: { main: brand.info, contrastText: '#fff' },
    grey: GREY,
    divider: light ? 'rgba(148,163,184,0.22)' : 'rgba(148,163,184,0.16)',
    text: light
      ? { primary: GREY[900], secondary: GREY[500], disabled: GREY[400] }
      : { primary: '#F1F5F9', secondary: '#94A3B8', disabled: '#64748B' },
    background: light
      ? { default: '#F6F7FB', paper: '#FFFFFF', neutral: '#F1F5F9' }
      : { default: '#0B1120', paper: '#111A2E', neutral: '#0F172A' },
    action: light
      ? { hover: 'rgba(99,102,241,0.06)', selected: 'rgba(99,102,241,0.12)' }
      : { hover: 'rgba(148,163,184,0.08)', selected: 'rgba(129,140,248,0.16)' },
  };
};
